const pageBaseStrings = {
  noTenantText: 'Loading Tenant Info',
};

export default pageBaseStrings;
